export const initDialogData = {
  ScId: 0,
  IsActv: 1,
  Name: "",
  SName: "",
  Abbr: "",
  Addr: "",
  Tel: "",
  TaxId: "",
  BrchNo: 0,
  IsHeadBrch: 1,
  CtDscp: "",
  CtMailOpr: "",
  CtMailAcc: "",
  XpssSupCod: "",
  Rmk: "",
  Email: null,
  Pass: "",
  IsSendEmail: 1,
  LnkSiteAbbr: "",
}

export const initFilterData = {
  AllName: null,
  IsActv: 1,
}

export const initSubcontractLinkJobDialogData = {
  JobSNm: "",
  JobId: "",
  LnkSiteAbbr: "",
  ScSNm: "",
  ScJobSNm: "",
  ScJobId: null,
}